export const PROFILE_POLL_INTERVAL_MS = 30_000;

export const shouldPollProfiles = (
  profiles: Array<{ syncingKeywords: number }>,
  visibilityState: DocumentVisibilityState,
) => visibilityState === "visible" && profiles.some((profile) => profile.syncingKeywords > 0);
